<template>
  <div class="page-content">
    <div class="movie-detail">
      <el-breadcrumb separator="/" class="egl-breadcrumb">
        <el-breadcrumb-item :to="{ path: '/movie' }">{{ $locale("sideMenu.film.library") }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $locale("movie.createEditMovie") }}</el-breadcrumb-item>
      </el-breadcrumb>

      <el-form
        class="egl-elm egl-detail"
        :model="form"
        :rules="formRules"
        ref="detailForm"
        label-position="top"
        :disabled="!editable"
      >
        <el-row>
          <el-col :span="12">
            <!-- 基本情報 -->
            <BasicInfo
              :formData="form"
              :formRef="$refs.detailForm"
              :movieList="movieList"
              :action="action"
              @getMoviTicketList="getMoviTicketList"
            ></BasicInfo>

            <!-- その他作品情報 -->
            <MoreInfo
              :formData="form"
              :formRef="$refs.detailForm"
              :genreOptions="genreOptions"
              :countryOptions="countryOptions"
              :directorOptions="directorOptions"
              :actorOptions="actorOptions"
              :distributorOptions="distributorOptions"
              :writerOptions="writerOptions"
              :category="categoryList"
            ></MoreInfo>

            <!-- HP表示 -->
            <HpDisplay
              :formData="form"
              :formRef="$refs.detailForm"
              :movieList="movieList"
            ></HpDisplay>
          </el-col>

          <el-col :span="10" :offset="2">
            <!-- カバーとトレーラー -->
            <CoversAndTrailer
              :formData="form"
              :formRef="$refs.detailForm"
            ></CoversAndTrailer>

            <!-- 販売設定 -->
            <SalesSettings
              :formData="form"
              :formRef="$refs.detailForm"
            ></SalesSettings>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <!-- 全国共通券 -->
            <NationwideUniversalTicket
              v-if="adminType !== 'superAdmin'"
              :formData="form"
              :distributorOptions="distributorOptions"
              :versionList="versionList"
              :isLoading="isLoading"
              :pageCounts="pageCounts"
              @getMoviTicketList="getMoviTicketList"
            ></NationwideUniversalTicket>

            <!-- フィルム料歩率 -->
            <FilmRate
              :formData="form"
              :formRef="$refs.detailForm"
            ></FilmRate>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <ApproveField v-if="adminType !== 'superAdmin'" v-model="form.approveDate" :formData="form" fieldName="approveDate" />
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="detail-page-btn">
      <el-button class="egl-btn-white" @click="cancelAction">{{ $locale("global.cancel") }}</el-button>
      <el-button class="egl-btn-yellow" @click="confirmAction">{{ $locale("global.confirm") }}</el-button>
    </div>

    <ApproveDialog
      :formData="form"
      :visible="approveShow"
      :approveCinemas="approveCinemas"
      :cinemaList="cinemas"
      @closeDialogAction="closeDialogAction"
      @saveFormAction="saveFormAction"
    ></ApproveDialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import {
  getGlobalMovieList,
  getCinemaList,
  // getSimpleMovieList,
} from "@/helpers/service/api/common.js";
import {
  createMovie,
  updateMovie,
  getFilmCompanyList,
  getMovieGenreListMapService,
  getMovieAreaListMapService,
  getMovieAreaListService,
  getMoviTicketListService,
  getMovieDetail,
} from "@/helpers/service/api/movie.js";
import { getVersionService } from "@/helpers/service/api/version";
import { getFilmList } from "@/helpers/service/api/report";
import { getClientListService, getMovieStaff } from "@/helpers/service/api/common";
import { getEthicalTagService } from "@/helpers/service/api/restrict";
import {
  initFormData,
  countryOptions,
  categoryBtns,
  formRules,
  shareItemRules,
  listApiTypeMapping,
  ticketCoordinationObj,
  noneOption,
  checkValidData,
} from "@/assets/js/movieStatic";
import { getAllMovieStaff } from "@/assets/js/film.js";// do some ting
import BasicInfo from "@/components/Movie/BasicInfo";
import MoreInfo from "@/components/Movie/MoreInfo";
import NationwideUniversalTicket from "@/components/Movie/NationwideUniversalTicket";
import CoversAndTrailer from "@/components/Movie/CoversAndTrailer";
import SalesSettings from "@/components/Movie/SalesSettings";
import HpDisplay from "@/components/Movie/HpDisplay";
import FilmRate from "@/components/Movie/FilmRate";
import ApproveDialog from "@/components/Movie/ApproveDialog";
import ApproveField from "@/components/common/ApproveField";
import { requestAll } from "@/helpers/service/axiosPlugin";
import countDownAlert from "@/utils/countDownAlert";
import {
  toThousands,
  dateFormat,
  formInvalidHandle,
  reverseThousandsFn,
  adminTypeList,
} from "@/utils/common";
import tranfResData from "@/utils/tranfResData";
import "@/assets/style/movie.less";

export default {
  name: "movie-detail",
  componentName: "movieDetail",
  components: {
    ApproveField,
    BasicInfo,
    MoreInfo,
    NationwideUniversalTicket,
    CoversAndTrailer,
    SalesSettings,
    HpDisplay,
    FilmRate,
    ApproveDialog,
  },
  data() {
    return {
      editable: true,
      form: initFormData(),
      movieList: [],
      companyList: [],
      movieId: "",
      genreOptions: [],
      countryOptions,
      distributorOptions: [],
      directorOptions: [],
      actorOptions: [],
      categoryBtns,
      approveShow: false,
      approveCinemas: {
        all: true,
        cinemas: [],
      },
      cinemas: [],
      formRules,
      shareItemRules,
      writerOptions: [],
      versionList: [],
      isLoading: null,
      currentMovie: {},
      moviTicketRequestTimes: 0,
      moviTicketfullDataRequestTimes: 0,
      pageSize: 10,
      pageCounts: 0,
      moviTicketWholeList: [],
      originMVTKList: {
        nt: [],
        ot: []
      },
      apiType: "film",
      tempAddNTs: [],
      // clientList: [],
      categoryList: [],
    };
  },
  provide() {
    return {
      apiTypeForChildren: this.apiType,
      getApiType: () => this.apiType,
      clientList: () => this.distributorOptions
    };
  },
  computed: {
    ...mapState("app", {
      adminType: state => state.adminType,
      cinemaId: state => state.cinemaId,
      brandId: state => state.brandId,
    }),
    ...mapState("api", {
      clientList: state => state.clientList
    }),
    action() {
      return this.movieId ? "update" : "create";
    },
  },
  created() {
    const _this = this;
    this.$on("pushList", function(val) {
      _this.tempAddNTs.push(val);
    });
    getClientListService({
      page: 0,
      pageSize: 20
    }).then(res => {
      this.distributorOptions = res.data.data;
    });
    getEthicalTagService().then(res => {
      this.categoryList = res.data.map(item => item.name);
    });
    // get filmMaker list
    // Actor
    getMovieStaff({
      role: "actor",
      field: ["id", "name"],
      page: 0,
      pageSize: 20,
    }).then(res => {
      if (res.data && res.data.data.length > 0) {
        this.actorOptions = res.data.data.map(item => ({
          id: item.id,
          name: item.name
        }));
      }
    });
    // Director
    getMovieStaff({
      role: "director",
      field: ["id", "name"],
      page: 0,
      pageSize: 20,
    }).then(res => {
      if (res.data && res.data.data.length > 0) {
        this.directorOptions = res.data.data.map(item => ({
          id: item.id,
          name: item.name
        }));
      }
    });
    // Writer
    getMovieStaff({
      role: "writer",
      field: ["id", "name"],
      page: 0,
      pageSize: 20,
    }).then(res => {
      if (res.data && res.data.data.length > 0) {
        this.writerOptions = res.data.data.map(item => ({
          id: item.id,
          name: item.name
        }));
      }
    });
    // get genre list
    getMovieGenreListMapService({
      field: ["id", "name"],
      page: 0,
      pageSize: 20,
    }).then(res => {
      if (res.data && res.data.data.length > 0) {
        this.genreOptions = res.data.data;
      }
    });
    // MovieArea List
    getMovieAreaListMapService({
      field: ["id", "name"],
      page: 0,
      pageSize: 20,
    }).then(res => {
      if (res.data && res.data.data.length > 0) {
        this.countryOptions = res.data.data;
      }
    });
  },
  mounted() {
    this.movieId = this.$route.params.id || "";
    this.initDataFn();
  },
  methods: {
    ...mapActions("api", ["setPageCount", "setClientList"]),
    saveFormAction(ids) {
      this.$refs.detailForm.validate(valid => {
        if (valid) {
          const obj = tranfResData(this.form);

          obj.id = this.movieId;
          obj.accountType = this.adminType;
          obj.releaseTime = this.$moment(obj.releaseTime).valueOf();
          // request must base64
          obj.synopsis = this.$util.encodeBase64(obj.synopsis);
          obj.profile = this.$util.encodeBase64(obj.profile);

          if (this.adminType === "brand") {
            obj.brandId = this.brandId;
          } else if (this.adminType === "cinema") {
            obj.cinemaId = this.cinemaId;
          } else {
            obj.cinemaId = "";
          }

          // handle share
          obj.share.forEach(item => {
            // item.eveningShare = item.eveningShare ? parseInt(item.eveningShare) : item.eveningShare;
            // item.morningShare = item.morningShare ? parseInt(item.morningShare) : item.morningShare;
            // item.normalShare = item.normalShare ? parseInt(item.normalShare) : item.normalShare;
            // item.overNightShare = item.overNightShare ? parseInt(item.overNightShare) : item.overNightShare;
            // item.specialShare = item.specialShare ? parseInt(item.specialShare) : item.specialShare;
            item.stableMoney = typeof(item.stableMoney) === "string" ?  parseInt(item.stableMoney.replace(/,/g, "")) : item.stableMoney;
            item.shareStartDate = typeof item.shareStartDate === "string" ? dateFormat(item.shareStartDate) : item.shareStartDate;
            item.shareEndDate = typeof item.shareEndDate === "string" ? dateFormat(item.shareEndDate) : item.shareEndDate;
          });

          // handle nationalTicket
          if (obj.national) {
            obj.nationalTicket.forEach(item => {
              item.actualAmount = reverseThousandsFn(item.actualAmount);
              item.boxOfficeAmount = reverseThousandsFn(item.boxOfficeAmount);
              item.sellAmount = reverseThousandsFn(item.sellAmount);
              item.type = "film";
              item.filmId = obj.id;
              item.cinemaMovieTicketId = item.id;

              item.checkMessages.forEach(_cm => {
                const isValidData = checkValidData(_cm);
                _cm.isValidData = isValidData;
              });
              item.checkMessages = item.checkMessages.filter(_cm => _cm.isValidData);
            });
          } else {
            obj.nationalTicket = [];
          }

          // handle otherNationalTicket
          if (obj.otherNational) {
            obj.otherNationalTicket.forEach(item => {
              item.actualAmount = reverseThousandsFn(item.actualAmount);
              item.boxOfficeAmount = reverseThousandsFn(item.boxOfficeAmount);
              item.sellAmount = reverseThousandsFn(item.sellAmount);

              item.checkMessages.forEach(_cm => {
                const isValidData = checkValidData(_cm);
                _cm.isValidData = isValidData;
              });
              item.checkMessages = item.checkMessages.filter(_cm => _cm.isValidData);
            });
          } else {
            obj.otherNationalTicket = [];
          }

          // handle actors/areas/genres/directors
          obj.actors.map((item, index) => {
            if (typeof item == "string") {
              obj.actors[index] = {
                // id: "",
                name: item
              };
            }
          });

          obj.areas.map((item, index) => {
            if (typeof item == "string") {
              obj.areas[index] = {
                id: "",
                name: item
              };
            }
          });

          obj.genres.map((item, index) => {
            if (typeof item == "string") {
              obj.genres[index] = {
                id: "",
                name: item
              };
            }
          });

          obj.directors.map((item, index) => {
            if (typeof item == "string") {
              obj.directors[index] = {
                name: item
              };
            }
          });

          obj.writers.map((item, index) => {
            if (typeof item == "string") {
              obj.writers[index] = {
                name: item
              };
            }
          });

          /**
           * compare which moviTicket data has changed
           */
          if (obj.nationalTicket.length > 0) {
            obj.nationalTicket.forEach(_nt => {
              this.moviTicketWholeList.forEach((_list, j) => {
                if (_list.id === _nt.id) {
                  this.moviTicketWholeList[j] = tranfResData(_nt);
                }
              });
            });

            obj.nationalTicket = tranfResData(this.moviTicketWholeList);
          }

          if (obj.id == "") {
            if (obj.approve !== undefined) {
              delete obj.approve;
            }
            obj.nationalTicke = this.tempAddNTs;
            createMovie({ filmInfo: obj, ...ids ? { filmListCinemaId: ids } : {} }).then(res => {
              if (res.success) {
                this.countDown(this.$locale("global.createSuccessfully"));
              } else {
                this.$alert(res.message, {
                  showClose: false,
                });
              }
            });
          } else {
            if (obj.reflect !== undefined) {
              delete obj.reflect;
            }

            updateMovie({ filmInfo: obj, ...ids ? { filmListCinemaId: ids } : {} }).then(res => {
              if (res.success) {
                this.countDown(this.$locale("global.updateSuccessfully"));
              } else {
                this.$alert(res.message, {
                  showClose: false,
                });
              }
            }).catch(() => {
              this.form.nationalTicket = this.originMVTKList.mt;
              this.form.otherNationalTicket = this.originMVTKList.ot;
            });
          }
        } else {
          formInvalidHandle();
        }
      });
    },
    getAllMovies(id) {
      return getGlobalMovieList({
        status: "active",
      }, false, false).then(res => {
        if (res.success) {
          this.movieList = tranfResData(res.data);

          if (id) {
            const targetMovie = this.movieList.find(movie => movie.id === id) || {};
            this.form = {
              ...this.form,
              ...targetMovie,
            };
          }
        }
      });
    },
    getFilmCompanyList_fn() {
      return getFilmCompanyList({
        page: 0,
        pageSize: 9999,
        status: "active",
      }, false, false).then(res => {
        if (res.success) {
          this.companyList = tranfResData(res.data.data);
        }
      });
    },
    getVersionList() {
      getVersionService({
        cinemaId: this.cinemaId,
        page: 0,
        pageSize: 9999,
      }).then(res => {
        this.versionList = [
          noneOption,
          ...tranfResData(res.data.data),
        ];
      });
    },
    countDown(str = this.$locale("global.createSuccessfully")) {
      countDownAlert({
        content: str,
        callback: () => {
          this.$router.go(-1);
        }
      });
    },
    getMovieDetail_fn() {
      let id = this.$route.params.id || "";

      if (id != "") {
        return new Promise((resolve, reject) => {
          getMovieDetail(id).then(res => {
            if (res.success) {
              resolve(res);
            } else {
              reject(err);
            }
          }).catch(err => {
            reject(err);
          });
        });
      }
      return new Promise((resolve, reject) => {
        resolve({});
      });

    },
    async initDataFn() {
      // this.getMoviTicketFullData();

      await requestAll([
        // getAllMovieStaff(),
        this.getAllMovies(this.movieId),
        this.getFilmCompanyList_fn(),
        this.getVersionList(),
        this.getMovieDetail_fn(),
        getCinemaList({ page: 0, pageSize: 9999 }),
        // getMovieGenreListService(),
        // getMovieAreaListService(),
        // getFilmList({
        //   page: 0,
        //   pageSize: 20,
        //   dailyReport: false,
        //   cinemaId: this.brandId || "123", // NOTICE: here need to pass the brand ID actually
        //   startDate: "2022-01-01",
        // }),
        // getClientListService({
        //   page: 0,
        //   pageSize: 20,
        //   field: ["id", "name"]
        // })
      ]).then(res => {
        if (res[3].data) {
          this.originMVTKList = {
            mt: res[3].data.nationalTicket.slice(0,10),
            ot: res[3].data.otherNationalTicket.slice(0,10)
          };
        }
        // let actor_arr = [];
        // let director_arr = [];

        // res[0].data.data.forEach(role => {
        //   if (role.roles.indexOf("actor") >= 0) {
        //     actor_arr.push({
        //       id: role.id,
        //       name: role.name,
        //     });
        //   }

        //   if (role.roles.indexOf("director") >= 0) {
        //     director_arr.push({
        //       id: role.id,
        //       name: role.name
        //     });
        //   }
        // });

        if (this.movieId) {
          this.currentMovie = res[3].data;
          if (this.currentMovie.nationalTicket) { this.currentMovie.nationalTicket = []; }

          this.form = {
            ...this.form,
            ...this.currentMovie,
            synopsis: this.$util.decodeBase64(this.currentMovie.synopsis),
            profile: this.$util.decodeBase64(this.currentMovie.profile),
            stills: this.currentMovie.stills.filter(item => item.trim().length > 0)
          };

          const {
            share,
            national,
            nationalTicket,
            otherNational,
            otherNationalTicket,
          } = this.form;

          share.forEach(item => {
            item.shareStartDate = this.$moment(item.shareStartDate).format("YYYY-MM-DD");
            item.shareEndDate = this.$moment(item.shareEndDate).format("YYYY-MM-DD");
            item.stableMoney = item.stableMoney === null ? null : toThousands(item.stableMoney);
          });

          if (national && nationalTicket.length === 0) {
            this.getMoviTicketList();
          }

          if (otherNational) {
            const _itemLength = otherNationalTicket.length - 1;
            if (otherNationalTicket[_itemLength].checkMessages.length === 0) {
              otherNationalTicket[_itemLength].checkMessages.push(tranfResData(ticketCoordinationObj));
            }
          }
        }

        this.movieList.forEach(item => {
          if (item.accountType === "superAdmin" && this.adminType === "cinema") {
            item.name = `${item.name}${this.$locale("movie.movieLand")}`;
          }
        });

        // this.actorOptions = actor_arr;
        // this.form.directors.forEach(item => {
        //   if (!this.directorOptions.find(director => director.id === item.id)) {
        //     this.directorOptions.push(item)
        //   }
        // })
        // this.form.writers.forEach(item => {
        //   if (!this.directorOptions.find(director => director.id === item.id)) {
        //     this.writerOptions.push(item);
        //   }
        // })
        // this.directorOptions = director_arr;
        // this.writerOptions = [...this.directorOptions, ...this.writerOptions];

        this.cinemas = res[4].data ? res[4].data.data || [] : [];
        // this.genreOptions = res[5].data || [];
        // this.countryOptions = res[6].data || [];
        // this.distributorOptions = res[8].data || [];
      });
    },
    confirmAction() {
      this.$refs.detailForm.validate(valid => {
        if (valid) {
          if (this.adminType === "brand") {
            this.showDialogAction();
          } else {
            this.saveFormAction();
          }
        } else {
          formInvalidHandle();
        }
      });
    },
    cancelAction() {
      this.$router.go(-1);
    },
    showDialogAction() {
      this.approveShow = true;
    },
    closeDialogAction() {
      this.approveShow = false;
    },
    async getMoviTicketFullData() {
      const requestParam = (this.action === "create" || this.moviTicketfullDataRequestTimes === 1) ? {
        ...(this.brandId && this.adminType === adminTypeList.BRAND ? { brandId: this.brandId } : {}),
        ...(this.cinemaId && this.adminType === adminTypeList.CINEMA ? { cinemaId: this.cinemaId } : {}),
        type: listApiTypeMapping[this.adminType],
        pageSize: 9999,
        page: 0,
      } : {
        type: "film",
        filmId: this.movieId,
        pageSize: 9999,
        page: 0,
      };

      await getMoviTicketListService(requestParam, false).then(res => {
        this.moviTicketfullDataRequestTimes += 1;
        const { data } = res.data || {};

        /**
         * get "type=film" first, if not any data, get "type=brand/cinema".
         */
        if (data.length > 0) {
          this.moviTicketWholeList = [ ...data ];
        } else if (this.moviTicketfullDataRequestTimes < 2) {
          this.getMoviTicketFullData();
        }
      });
    },
    async getMoviTicketList(currentPage = 0) {
      this.isLoading = true;

      const requestParam = (this.action === "create" || this.moviTicketRequestTimes > 0) ? {
        ...(this.brandId && this.adminType === adminTypeList.BRAND ? { brandId: this.brandId } : {}),
        ...(this.cinemaId && this.adminType === adminTypeList.CINEMA ? { cinemaId: this.cinemaId } : {}),
        type: listApiTypeMapping[this.adminType],
        pageSize: this.pageSize,
        page: currentPage,
      } : {
        type: "film",
        filmId: this.movieId,
        pageSize: this.pageSize,
        page: currentPage,
      };

      const vm = this;
      this.$nextTick(await function() {
        getMoviTicketListService(requestParam, false).then(res => {
          vm.moviTicketRequestTimes += 1;
          const { data, count } = res.data || {};

          vm.pageCounts = count;

          vm.form.nationalTicket = [
            ...vm.form.nationalTicket,
            ...data,
          ];

          /**
           * get "type=film" first, if not any data, get "type=brand/cinema".
           */
          vm.setPageCount(res.data.count);
          if (data.length > 0) {
            vm.form.nationalTicket.forEach(_ticket => {
              // _ticket.actualAmount = toThousands(_ticket.actualAmount);
              // _ticket.boxOfficeAmount = toThousands(_ticket.boxOfficeAmount);
              // _ticket.sellAmount = toThousands(_ticket.sellAmount);

              if (!_ticket.usableVersion1 && vm.versionList && vm.versionList.length > 0) {
                _ticket.usableVersion1 = vm.versionList[0].id;
              }

              switch(vm.adminType) {
              case adminTypeList.BRAND:
                _ticket.brandParentId = _ticket.id;
                _ticket.brandId = vm.brandId;
                break;
              case adminTypeList.CINEMA:
                _ticket.cinemaParentId = _ticket.id;
                _ticket.cinemaId = vm.cinemaId;
                break;
              default:
                break;
              }

              if (_ticket.checkMessages.length === 0) {
                _ticket.checkMessages.push(tranfResData(ticketCoordinationObj));
              }
            });
          }
          else if (vm.moviTicketRequestTimes < 2) {
            vm.apiType = "global";
            vm.getMoviTicketList();
          }
        }).finally(() => {
          vm.isLoading = false;
        });
      });
    },
  },
  watch: {
    "form.distributor": {
      deep: false,
      handler(val) {
        if (val.length > 0 && this.$route.path.indexOf("update") > -1) {
          getClientListService({
            name: val,
            page: 0,
            pageSize: 9999
          }).then(res => {
            this.distributorOptions = this.$_.uniqBy([...res.data.data, ...this.distributorOptions], "id");
          });
        }
      }
    },
    "form.id": {
      deep: false,
      handler(val) {
        if (val.length > 0 && this.$route.path.indexOf("update") > -1) {
          // Mapping Selected Staff ID
          getMovieStaff({
            ids: [
              ...this.form.actors.map(item => item.id),
              ...this.form.directors.map(item => item.id),
              ...this.form.writers.map(item => item.id),
            ],
            field: ["id", "name", "roles"],
            page: 0,
            pageSize: 20,
          }).then(res => {
            if (res.data && res.data.data.length > 0) {
              let _actors = [];
              let _directors = [];
              let _writers = [];
              res.data.data.forEach(item => {
                if (item.roles.indexOf("actor") > -1) {
                  _actors.push(item);
                } else if (item.roles.indexOf("director") > -1) {
                  _directors.push(item);
                } else {
                  _writers.push(item);
                }
              });
              this.actorOptions = this.$_.uniqBy([..._actors, ...this.actorOptions], "id");
              this.directorOptions = this.$_.uniqBy([..._directors, ...this.directorOptions], "id");
              this.writerOptions = this.$_.uniqBy([..._writers, ...this.writerOptions], "id");
            }
          });
          // Mapping Selected MovieGenre ID
          getMovieGenreListMapService({
            ids: [ ...this.form.genres.map(item => item.id) ],
            field: ["id", "name"],
            page: 0,
            pageSize: 99999,
          }).then(res => {
            if (res.data && res.data.data.length > 0) {
              this.genreOptions = this.$_.uniqBy([...res.data.data, ...this.genreOptions], "id");
            }
          });
          // Mapping Selected MovieArea ID
          getMovieAreaListMapService({
            ids: [ ...this.form.areas.map(item => item.id) ],
            field: ["id", "name"],
            page: 0,
            pageSize: 99999,
          }).then(res => {
            if (res.data && res.data.data.length > 0) {
              this.countryOptions = this.$_.uniqBy([...res.data.data, ...this.countryOptions], "id");
            }
          });
        }
      }
    }
  }
};
</script>

<style scoped>
.movie-detail {
  padding-bottom: 30px;
}
</style>
